import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
// import vendors from '../../constants/vendors';
import { useParams } from 'react-router-dom';
import { useFormFields } from '../../libs/hooksLib';
import { logError } from '../../libs/errorLib';
import { Alert } from 'reactstrap';
import Loader from '../common/Loader';
import { vendorIsReadOnlyCheck } from '../../helpers/rbac';

import { VendorsContext } from '../../context/VendorsContext';
import { DashboardContext, ServiceNowIntegrationContext } from '../../context/DashboardContext';
import { TenantSettingsContext } from '../../context/TenantSettingsContext';
import { CoverageInline } from '../dashboard/BugCoverage';

// config forms
import ConfigFormAzure from '../managed-product/config-forms/ConfigFormAzure';
import ConfigFormAwsConfig from '../managed-product/config-forms/ConfigFormAwsConfig';
import ConfigFormAwsResilienceHub from '../managed-product/config-forms/ConfigFormAwsResilienceHub';
import ConfigFormAwsSecurityHub from '../managed-product/config-forms/ConfigFormAwsSecurityHub';
import ConfigFormRedHat from '../managed-product/config-forms/ConfigFormRedHat';
// import ConfigFormHPE from '../managed-product/config-forms/ConfigFormHPE';
import ConfigFormFortinet from '../managed-product/config-forms/ConfigFormFortinet';
import ConfigFormCisco from '../managed-product/config-forms/ConfigFormCisco';
import ConfigFormServiceNow from '../managed-product/config-forms/ConfigFormServiceNow';
import ConfigFormMSFT365 from '../managed-product/config-forms/ConfigFormMSFT365';
import ConfigFormMongoDB from '../managed-product/config-forms/ConfigFormMongoDB';
import ConfigFormVmware from '../managed-product/config-forms/ConfigFormVmware';
import ConfigFormVmwareESXi from '../managed-product/config-forms/ConfigFormVmwareESXi';
import ConfigFormVmwareVCenter from '../managed-product/config-forms/ConfigFormVmwareVCenter';
import ConfigFormVeeam from '../managed-product/config-forms/ConfigFormVeeam';
import ConfigFormNetApp from '../managed-product/config-forms/ConfigFormNetApp';
import ConfigFormMSFT from '../managed-product/config-forms/ConfigFormMSFT';
import ConfigFormMSFTAccess from '../managed-product/config-forms/ConfigFormMSFTAccess';
import ConfigFormMSFTSqlServer from '../managed-product/config-forms/ConfigFormMSFTSqlServer';
import ConfigFormMSFTWindowsServer from '../managed-product/config-forms/ConfigFormMSFTWindowsServer';
import ConfigFormAWS from '../managed-product/config-forms/ConfigFormAWS';
import ConfigFormF5 from '../managed-product/config-forms/ConfigFormF5';
import ConfigFormCitrixNetScaler from '../managed-product/config-forms/ConfigFormCitrixNetScaler';
import ConfigFormCitrixXenDesktop from '../managed-product/config-forms/ConfigFormCitrixXenDesktop';
import ConfigFormPaloAlto from '../managed-product/config-forms/ConfigFormPaloAlto';
import ConfigFormPostgreSQL from '../managed-product/config-forms/ConfigFormPostgreSQL';
import ConfigFormLogicMonitor from '../managed-product/config-forms/ConfigFormLogicMonitor';
import ConfigFormVMWareNSX from '../managed-product/config-forms/ConfigFormVMWareNSX';
import DynamicConfigForm from '../managed-product/dynamic-form/DynamicConfigForm';
// Local schema files (temporary - will be replaced by API responses)
import postgreSchema from '../managed-product/dynamic-form/schemas/postgre.json';
import ctrxnsSchema from '../managed-product/dynamic-form/schemas/ctrxns.json';
import ctrxxenSchema from '../managed-product/dynamic-form/schemas/ctrxxen.json';
import msftaccessSchema from '../managed-product/dynamic-form/schemas/msftaccess.json';
import veeamSchema from '../managed-product/dynamic-form/schemas/veeam.json';
import vmwareesxSchema from '../managed-product/dynamic-form/schemas/vmwareesx.json';
import fortinetSchema from '../managed-product/dynamic-form/schemas/fortinet.json';
import vmwarevcSchema from '../managed-product/dynamic-form/schemas/vmwarevc.json';
import vmwarensxSchema from '../managed-product/dynamic-form/schemas/vmwarensx.json';
import rhSchema from '../managed-product/dynamic-form/schemas/rh.json';
import f5Schema from '../managed-product/dynamic-form/schemas/f5.json';
import msftsqlSchema from '../managed-product/dynamic-form/schemas/msftsql.json';
import mongodbSchema from '../managed-product/dynamic-form/schemas/mongodb.json';
import paloaltoSchema from '../managed-product/dynamic-form/schemas/paloalto.json';
import msftSchema from '../managed-product/dynamic-form/schemas/msft.json';
import msft365Schema from '../managed-product/dynamic-form/schemas/msft365.json';
import msftserverSchema from '../managed-product/dynamic-form/schemas/msftserver.json';
import logmonSchema from '../managed-product/dynamic-form/schemas/logmon.json';
import snSchema from '../managed-product/dynamic-form/schemas/sn.json';
import awsSchema from '../managed-product/dynamic-form/schemas/aws.json';
import awsconfigSchema from '../managed-product/dynamic-form/schemas/awsconfig.json';
import awsreshubSchema from '../managed-product/dynamic-form/schemas/awsreshub.json';
import awssechubSchema from '../managed-product/dynamic-form/schemas/awssechub.json';
import azureSchema from '../managed-product/dynamic-form/schemas/azure.json';
import ciscoSchema from '../managed-product/dynamic-form/schemas/cisco.json';
import netappSchema from '../managed-product/dynamic-form/schemas/netapp.json';
import vmwareSchema from '../managed-product/dynamic-form/schemas/vmware.json';
import kubernetesSchema from '../managed-product/dynamic-form/schemas/kubernetes.json';
import BZAPIService from '../../services/BZAPIService';

import { isEmpty } from 'lodash';
import SERVICENOW from '../../constants/servicenow';
import SETTINGS from '../../constants/settings';

const managedProductForms = {
  aws: ConfigFormAWS,
  awsconfig: ConfigFormAwsConfig,
  awsreshub: ConfigFormAwsResilienceHub,
  awssechub: ConfigFormAwsSecurityHub,
  azure: ConfigFormAzure,
  rh: ConfigFormRedHat,
  // hpe: ConfigFormHPE,
  f5: ConfigFormF5,
  ctrxns: ConfigFormCitrixNetScaler,
  ctrxxen: ConfigFormCitrixXenDesktop,
  msft: ConfigFormMSFT,
  msft365: ConfigFormMSFT365,
  msftaccess: ConfigFormMSFTAccess,
  msftsql: ConfigFormMSFTSqlServer,
  msftserver: ConfigFormMSFTWindowsServer,
  cisco: ConfigFormCisco,
  sn: ConfigFormServiceNow,
  mongodb: ConfigFormMongoDB,
  vmware: ConfigFormVmware,
  vmwareesx: ConfigFormVmwareESXi,
  vmwarevc: ConfigFormVmwareVCenter,
  veeam: ConfigFormVeeam,
  logmon: ConfigFormLogicMonitor,
  netapp: ConfigFormNetApp,
  fortinet: ConfigFormFortinet,
  paloalto: ConfigFormPaloAlto,
  postgre: ConfigFormPostgreSQL,
  vmwarensx: ConfigFormVMWareNSX
};

// Vendor IDs that have been migrated to the dynamic form renderer.
// Add vendor IDs here to switch them from their static ConfigForm to DynamicConfigForm.
const DYNAMIC_FORM_VENDORS = [
  'postgre',
  'ctrxns',
  'ctrxxen',
  'msftaccess',
  'veeam',
  'vmwareesx',
  'fortinet',
  'vmwarevc',
  'vmwarensx',
  'rh',
  'f5',
  'msftsql',
  'mongodb',
  'paloalto',
  'msft',
  'msft365',
  'msftserver',
  'logmon',
  'sn',
  'aws',
  'awsconfig',
  'awsreshub',
  'awssechub',
  'azure',
  'cisco',
  'netapp',
  'vmware'
];

// Local schema lookup (temporary - will be replaced by vendorData.formSchema from API)
export const LOCAL_FORM_SCHEMAS = {
  postgre: postgreSchema.formSchema,
  ctrxns: ctrxnsSchema.formSchema,
  ctrxxen: ctrxxenSchema.formSchema,
  msftaccess: msftaccessSchema.formSchema,
  veeam: veeamSchema.formSchema,
  vmwareesx: vmwareesxSchema.formSchema,
  fortinet: fortinetSchema.formSchema,
  vmwarevc: vmwarevcSchema.formSchema,
  vmwarensx: vmwarensxSchema.formSchema,
  rh: rhSchema.formSchema,
  f5: f5Schema.formSchema,
  msftsql: msftsqlSchema.formSchema,
  mongodb: mongodbSchema.formSchema,
  paloalto: paloaltoSchema.formSchema,
  msft: msftSchema.formSchema,
  msft365: msft365Schema.formSchema,
  msftserver: msftserverSchema.formSchema,
  logmon: logmonSchema.formSchema,
  sn: snSchema.formSchema,
  aws: awsSchema.formSchema,
  awsconfig: awsconfigSchema.formSchema,
  awsreshub: awsreshubSchema.formSchema,
  awssechub: awssechubSchema.formSchema,
  azure: azureSchema.formSchema,
  cisco: ciscoSchema.formSchema,
  netapp: netappSchema.formSchema,
  vmware: vmwareSchema.formSchema,
  kubernetes: kubernetesSchema.formSchema
};

export default function ManagedProductConfig() {
  const { vendorId } = useParams();
  const [vendor, setVendor] = useState();
  const [loading, setLoading] = useState(true);
  // const [vendor, setVendor] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [allRequired, setAllRequired] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [settings, setSettings] = useState(null);
  const [snCompanySysIdOptions, setSnCompanySysIdOptions] = useState({});
  const [snCompanySysIdErrors, setSnCompanySysIdErrors] = useState(true);
  const [awsResHub, setAwsResHub] = useState(null);
  const [vendorStatuses, setVendorStatuses] = useState([]);
  const [vendorSupportStatus, setVendorSupportStatus] = useState([]);
  const [vendorResolutions, setVendorResolutions] = useState([]);
  const [vendorRiskCategories, setVendorRiskCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [vendorEventScopes, setVendorEventScopes] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [awsOrgHealthEnabled, setAwsOrgHealthEnabled] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [subscriptionOptions, setSubscriptionOptions] = useState([]);
  const [vendorBugTypes, setVendorBugTypes] = useState([]);
  const [vendorBugCategories, setVendorBugCategories] = useState([]);
  const [vendorProductBugCategories, setVendorProductBugCategories] = useState([]);
  const [vendorBugServices, setVendorBugServices] = useState([]);
  const [vendorMitigationTypes, setVendorMitigationTypes] = useState([]);
  // const [vendorEventLevels, setVendorEventLevels] = useState([]);
  const [vendorImpactedRegions, setVendorImpactedRegions] = useState([]);
  const [vendorComplianceStatus, setVendorComplianceStatus] = useState([]);
  // const [supportCasesCount, setCases] = useState(0);
  const [isCve, setIsCve] = useState();
  const [excludedComponents, setExcludedComponents] = useState([]);

  const [autoClose, setAutoClose] = useState(false);
  const [autoCloseBugTicket, setAutoCloseBugTicket] = useState(false);

  const [bugRisk, setBugRisk] = useState([]);
  const [resiliencyData, setResiliencyData] = useState([]);

  const [services, setServices] = useState([]);
  const [isServiceActive, setIsServiceActive] = useState(false);
  const [activeVendors, setActiveVendors] = useState([]);
  const [bugs, setBugs] = useState({});
  const [priorityStats, setPriorityStats] = useState({});
  // Use ServiceNow integration context instead of local state
  // eslint-disable-next-line
  const [snIntegration, setSnIntegration] = useContext(ServiceNowIntegrationContext);
  const snIntegrationCheck = snIntegration?.isConfigured || false;
  const [priorityMaps, setPriorityMaps] = useState([]);
  const [snCompanySysId, setSnCompanySysId] = useState({});
  const [isConfigured, setIsConfigured] = useState(true);

  const [keywords, setKeywords] = useState([]);
  const [searchFields, setSearchFields] = useState([]);
  const snPriorityOptions = SERVICENOW.SN_PRIORITY_OPTIONS;

  const [bugsDateBack, setBugsDateBack] = useState('');
  const [vendorContractType, setVendorContractType] = useState({});
  const [enableChatGptPriority, setEnableChatGptPriority] = useState(false);
  const [aiRequired, setAiRequired] = useState(false);
  const [vendorAiEnabled, setVendorAiEnabled] = useState(false);
  const [initialEnableChatGptPriority, setInitialEnableChatGptPriority] = useState(false);
  const [aiToggleNeedsResave, setAiToggleNeedsResave] = useState(false);

  const [syncOnly, setSyncOnly] = useState(false);
  const [excludedApps, setExcludedApps] = useState([]);

  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  // eslint-disable-next-line
  const [dashboard, setDashboard] = useContext(DashboardContext);
  const { bugCoverageEnabled, isLoaded: tenantSettingsLoaded } = useContext(TenantSettingsContext);

  const [fields, handleFieldChange] = useFormFields({
    secretId: '',
    refreshToken: '',
    serviceSecretId: '',
    // serviceClientId: '',
    // serviceClientSecret: '',
    supportSecretId: '',
    supportClientId: '',
    supportClientSecret: '',
    // bugsDateBack: '',
    snCompanySysId: '',
    snAffectedCIQuery: '',
    cloudAppsUser: '',
    cloudAppsPass: '',
    cloudLoginId: '',
    username: '',
    password: '',
    mfaSecret: '',
    awsApiHealthApiRoleArn: '',
    clientSecret: '',
    tenantId: '',
    appId: ''
  });

  const bugOptions = [
    { value: 'bugsLastWeek', label: 'Last 7 Days' },
    { value: 'bugsLastMonth', label: 'Last 30 Days' },
    { value: 'bugsLastQuarter', label: 'Last 90 Days' }
  ];

  const [selectedBugOption, setSelectedBugOption] = useState(bugOptions[0]);

  function buildVendorStat(dataSet, colors) {
    const vendorPriorityStats = {};
    vendors?.map(v => {
      return (vendorPriorityStats[v.id] = []);
    });

    dataSet?.map((bugPriority, id) => {
      if (!vendorPriorityStats[bugPriority.vendorId]) vendorPriorityStats[bugPriority.vendorId] = [];
      const colorIndex = vendorPriorityStats[bugPriority.vendorId].length;

      const vendorPriorityStat = {
        id,
        value: bugPriority.priorityCount,
        name: bugPriority.priority,
        color: bugPriority.priority === 'Unspecified' ? '#90919a' : colors[colorIndex]
      };
      return vendorPriorityStats[bugPriority.vendorId].push(vendorPriorityStat);
    });

    // If no data, add 0 data for graph
    Object.keys(vendorPriorityStats).map((key, index) => {
      if (!vendorPriorityStats[key].length) {
        const vendorPriorityStat = {
          id: `z${index}`,
          value: 0.01, // Avoid NaN on graph and don't divide by 0
          name: 'No Bugs',
          color: '#d8d4ce'
        };
        vendorPriorityStats[key].push(vendorPriorityStat);
      }
      return vendorPriorityStats;
    });
    return vendorPriorityStats;
  }

  async function onLoad(v) {
    try {
      // Load permissions first so a failure in the Promise.all below can't leave the page stuck as read-only
      const myUserPermissionsData = await BZAPIService.getMyUserPermissions();
      setIsReadOnly(vendorIsReadOnlyCheck(vendorId, myUserPermissionsData));

      const settingsPromise = BZAPIService.getSetting(vendorId);
      const serviceStatusPromise = BZAPIService.getStatus(vendorId);
      // Look the saved company up by sys_id: the unfiltered list stops at 500 names, so
      // a company past that would leave the field blank.
      const companiesPromise = settingsPromise.then(s =>
        BZAPIService.integrationServiceNowCompanies(s?.snCompanySysId)
      );
      const vendorAiSettingsPromise = BZAPIService.getVendorAiSetting(vendorId);

      // If ServiceNow integration status hasn't been checked yet (isConfigured === null),
      // fetch it and update the context
      let snIntegrationPromises = [];
      if (snIntegration?.isConfigured === null) {
        snIntegrationPromises = [BZAPIService.getSetting(SETTINGS.SERVICE_NOW), BZAPIService.sNConectionTest()];
      }

      const [settings, serviceStatus, companies, vendorAiSettings, ...snResults] = await Promise.all([
        settingsPromise,
        serviceStatusPromise,
        companiesPromise,
        vendorAiSettingsPromise,
        ...snIntegrationPromises
      ]);

      // Update ServiceNow integration context if we fetched it
      if (snResults.length === 2) {
        const [snIntegrationCheckData, snIntegrationTestData] = snResults;
        const isConfigured = !isEmpty(snIntegrationCheckData) && snIntegrationTestData?.valid ? true : false;
        setSnIntegration({
          isConfigured: isConfigured,
          testResult: snIntegrationTestData || {}
        });
      }

      setSettings(settings);
      console.log('vendorId', vendorId, settings);

      // Set AI priority filtering based on vendor and global AI settings
      const isAiEnabled = vendorAiSettings?.vendor?.aiEnabled && vendorAiSettings?.globalAi?.aiEnabled;
      setEnableChatGptPriority(isAiEnabled || false);
      setInitialEnableChatGptPriority(isAiEnabled || false);
      // Vendors with aiRequired cannot run without AI — the save guard needs this.
      setAiRequired(!!vendorAiSettings?.vendor?.aiRequired);
      // Vendor-level AI flag only (not ANDed with globalAi) — the save guard
      // matches the backend's aiRequired gate, which checks only
      // vendorAiSettings.aiEnabled and never looks at Global AI.
      setVendorAiEnabled(!!vendorAiSettings?.vendor?.aiEnabled);
      setIsServiceActive(!!serviceStatus?.data?.enabled);

      if (!companies || isEmpty(companies)) {
        setSnCompanySysIdErrors(true);
      } else {
        const snCompanySysId = companies?.companies
          ? companies.companies.find(o => o.value === settings?.snCompanySysId)
          : {};
        setSnCompanySysId(snCompanySysId);
        setSnCompanySysIdErrors(false);
        setSnCompanySysIdOptions(companies);
      }

      // Clear up creds
      fields.username = '';
      fields.password = '';
      fields.mfaSecret = '';
      fields.tenantId = '';
      fields.appId = '';
      fields.clientSecret = '';
      fields.secretId = '';

      setBugsDateBack(settings?.bugsDateBack || '');
      fields.snCompanySysId = settings?.snCompanySysId || '';
      fields.snAffectedCIQuery = settings?.snAffectedCIQuery || '';
      fields.secretId = settings?.secretId;
      fields.serviceSecretId = settings?.serviceSecretId;
      fields.supportSecretId = settings?.supportSecretId;
      fields.snAffectedCIQuery = settings?.snAffectedCIQuery || '';
      fields.cloudLoginId = settings?.cloudLoginId || '';

      // if bug risk settings, compare length, add new defaults if any
      if (settings?.bugRiskScore?.length) {
        const settingsBugs = settings?.bugRiskScore;
        const settingsLength = settings?.bugRiskScore?.length;
        const defaultsLength = v?.vendorData?.bugRiskScore?.length;
        if (defaultsLength > settingsLength) {
          const newDefaults = v?.vendorData?.bugRiskScore?.slice(settingsLength);
          setBugRisk(settingsBugs.concat(newDefaults));
        } else {
          setBugRisk(settingsBugs);
        }
      }
      // If no bug risk score settings, set defaults
      if (!settings?.bugRiskScore?.length) setBugRisk(v?.vendorData?.bugRiskScore);
      if (settings?.excludedApps?.length) setExcludedApps(settings?.excludedApps);
      if (settings?.resiliencyData?.length) setResiliencyData(settings?.resiliencyData);

      if (!settings?.awsreshub) setAwsResHub(v?.vendorData?.awsreshub);
      if (settings?.vendorComplianceStatus) setVendorComplianceStatus(settings.vendorComplianceStatus);
      if (settings?.accountOrgs) setOrganizations(settings.accountOrgs);
      if (Array.isArray(settings?.awsOrgAccounts)) setOrganizations(settings.awsOrgAccounts);
      if (settings?.awsOrgHealthEnabled) setAwsOrgHealthEnabled(Boolean(settings.awsOrgHealthEnabled));
      if (v?.vendorData?.accountOrgs) setOrganizationOptions(v.vendorData.accountOrgs);
      if (settings?.subscriptions) setSubscriptions(settings?.subscriptions);
      if (v?.vendorData?.subscriptions) setSubscriptionOptions(v.vendorData.subscriptions);
      if (settings?.activeIqCustomers) setCustomers(settings?.activeIqCustomers);
      // The auto-close toggle persists under `autoCloseBugTicket` (see savePayload
      // mapField + the backend read key); hydrate the toggle state from it so it
      // reflects the saved value on reload. `settings.autoClose` is never written.
      if (settings?.autoCloseBugTicket) setAutoClose(settings?.autoCloseBugTicket);

      if (settings?.autoCloseBugTicket) setAutoCloseBugTicket(settings?.autoCloseBugTicket || false);

      setVendorResolutions(settings?.vendorBugResolutions);
      if (vendorId === 'postgre') {
        setVendorStatuses(settings?.vendorStatuses?.length > 1 ? settings?.vendorStatuses : v.vendorData.statuses);
      } else {
        setVendorStatuses(settings?.vendorStatuses);
      }
      if (settings?.vendorSupportStatus) {
        setVendorSupportStatus(settings?.vendorSupportStatus);
      }

      setVendorEventScopes(settings?.vendorEventScopes);
      setVendorBugTypes(settings?.vendorBugTypes);
      setVendorBugCategories(settings?.vendorBugCategories);
      setVendorBugServices(settings?.vendorBugServices);
      setVendorProductBugCategories(settings?.vendorBugModules);
      // setVendorEventLevels(settings?.vendorEventLevels);
      // Saved regions are persisted as bare values (savePayload unwrapValueList),
      // but react-select labels chips from value[i].label — so bare strings render
      // as blank chips. Normalize to {label,value} on load (region code is its own
      // label). Objects pass through; save re-unwraps to values. #454
      setVendorImpactedRegions(
        (settings?.vendorImpactedRegions || []).map(r => (r && typeof r === 'object' ? r : { label: r, value: r }))
      );
      setVendorRiskCategories(settings?.vendorRiskCategories);
      setVendorMitigationTypes(settings?.vendorMitigationTypes);

      setIsCve(
        settings === undefined || settings?.filterCVEs === undefined ? v?.vendorData?.filterCVEs : settings?.filterCVEs
      );

      settings?.excludedBugComponents
        ? setExcludedComponents(settings?.excludedBugComponents)
        : setExcludedComponents([]);

      // setIncludedComponents(defaults.vendorData.vendorBugComponents);

      if (v?.vendorData?.searchFields) {
        setSearchFields(v?.vendorData?.searchFields);
      } else {
        setSearchFields([]);
      }
      settings?.excludedKws ? setKeywords(settings?.excludedKws) : setKeywords([]);
      if (settings?.searchFields?.length) {
        setSearchFields(settings?.searchFields);
      }

      // Load vendor contract type for Cisco
      if (vendorId === 'cisco' && settings?.vendorContractType) {
        setVendorContractType(settings.vendorContractType);
      }

      const priorityMaps = settings?.vendorPriorities?.map(priority => {
        const result = {
          vendorPriority: v?.vendorData?.priorities?.find(e => e.value === priority.value),
          snPriority: snPriorityOptions?.find(e => e.value === priority.snPriority)
        };
        return result;
      });
      setPriorityMaps(priorityMaps);

      const service = dashboard?.services?.filter(service => {
        return service.vendorId === vendorId ? service : null;
      });
      setIsConfigured(
        service?.length && service[0]?.status === 'NOT CONFIGURED'
          ? false
          : service?.length && service[0]?.status === 'OPERATIONAL'
          ? true
          : true
      );
      setSyncOnly(
        service?.length && service[0]?.status === 'NOT CONFIGURED'
          ? true
          : service?.length && service[0]?.status === 'OPERATIONAL'
          ? false
          : false
      );
      setServices(dashboard?.services);

      const activeVendors = vendors?.filter(vendor => v.active);
      setActiveVendors(activeVendors);
      // Setup vendor priority stats
      const colors = [
        '#ff475f',
        '#000000',
        '#961ca2',
        '#35bc8e',
        '#90919a',
        '#c1bdb7',
        '#B54E34',
        '#253544',
        '#48384B',
        '#816577',
        '#445A57',
        '#617E71',
        '#829A92',
        '#567387',
        '#8096A8',
        '#816477'
      ];
      const bugsLastWeek = buildVendorStat(dashboard?.bugsLastWeek, colors);
      const bugsLastMonth = buildVendorStat(dashboard?.bugsLastMonth, colors);
      const bugsLastQuarter = buildVendorStat(dashboard?.bugsLastQuarter, colors);
      const bugs = {
        bugsLastWeek,
        bugsLastMonth,
        bugsLastQuarter
      };
      setPriorityStats(bugsLastWeek);
      setBugs(bugs);
      setLoading(false);
    } catch (e) {
      logError(e);
      console.log(e);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (vendors?.length) {
      const v = vendors?.filter(v => v.id === vendorId);
      setVendor(v[0]);
      console.log('setVendor', v[0]);
      setPriorityMaps([]);
      // Reset AI gate state on vendor switch: if the AI settings fetch fails
      // in onLoad, setAiRequired/setVendorAiEnabled below are skipped and a
      // stale value from the previous vendor would otherwise leak in and
      // incorrectly block (or wrongly permit) saving the new vendor's config.
      setAiRequired(false);
      setVendorAiEnabled(false);
      setLoading(true);
      if (v?.length) onLoad(v[0]);
    }
    setAllRequired(false);
    setIsUpdated(false);
    // eslint-disable-next-line
  }, [vendorId, vendors]);

  // Get current vendor name directly from vendors context for immediate updates
  const currentVendor = vendors?.find(v => v.id === vendorId);
  const currentVendorName = currentVendor?.name;

  // This vendor's bug coverage (STRY0038808) — present for enabled Prevent vendors.
  const vendorCoverage = dashboard?.bugCoverage?.find(c => c.vendorId === vendorId);

  // Header status badge — reflect the REAL bug service status (same source as the
  // Overview bug-service card: dashboard service entry `${vendorId}-bs`), rather
  // than a static "Active". Surfaces "Not configured", "Error", etc. in the header.
  const bugServiceStatus = dashboard?.services?.find(s => s?.id === vendorId + '-bs')?.status;
  const bugServiceStatusMeta = (() => {
    switch (bugServiceStatus) {
      case 'OPERATIONAL':
        return { className: 'bz-pill bz-pill--ok', label: 'Active' };
      case 'NOT CONFIGURED':
        return { className: 'bz-pill', label: 'Not configured' };
      case 'ERROR':
        return { className: 'bz-pill bz-pill--bad', label: 'Error' };
      case 'PENDING':
        return { className: 'bz-pill bz-pill--warn', label: 'Pending' };
      case 'RUNNING':
        return { className: 'bz-pill bz-pill--info', label: 'Running' };
      default:
        return { className: 'bz-pill', label: 'Not active' };
    }
  })();

  const handleAiEnabledChange = (newAiEnabled, options = {}) => {
    setEnableChatGptPriority(!!newAiEnabled);
    // Keep the vendor-level flag in step with the AI tab, which saves the toggle
    // immediately. Its controls are disabled while Global AI is off, so any change
    // reported here is the vendor flag itself. Without this, vendorAiEnabled stays at
    // its page-load value and the schema's aiOffWarning (and the aiRequired save
    // guard) go stale until a reload.
    setVendorAiEnabled(!!newAiEnabled);
    if (options.resetPriorityMaps) {
      setPriorityMaps([]);
      setAiToggleNeedsResave(true);
    }
  };

  // Hide the header and form until the vendor details have fully loaded — avoids
  // the partially-rendered header (skeleton title, missing name/status) flashing
  // before the vendor name is fetched.
  if (loading) {
    return <Loader text="Loading vendor configuration..." />;
  }

  return (
    <>
      {/* Identity header (BugZero design). Presentational only — surfaces
          existing vendor state; adds no new actions or editable values. */}
      <div
        className="bz-card"
        style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '16px 20px', marginBottom: 20 }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            background: 'var(--bg-tan)',
            color: 'var(--bz-blue-2)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: 18,
            flexShrink: 0
          }}
        >
          {(currentVendorName || 'V').charAt(0).toUpperCase()}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="bz-kicker" style={{ color: 'var(--prevent)' }}>
            Vendor configuration
          </div>
          <div className="bz-row" style={{ gap: 10, marginTop: 2 }}>
            <h1 className="bz-h2" style={{ margin: 0 }} data-testid="heading">
              {loading ? (
                <span
                  className="loading-skeleton"
                  style={{ display: 'inline-block', width: 200, height: '1em', borderRadius: 4 }}
                />
              ) : (
                currentVendorName?.replace('Systems', 'Networks') || 'Vendor'
              )}
            </h1>
            {!loading && (
              <span className={bugServiceStatusMeta.className}>
                <span className="bz-dot" />
                {bugServiceStatusMeta.label}
              </span>
            )}
            {!loading && isReadOnly && <span className="bz-pill bz-pill--warn">Read-only</span>}
          </div>
          <div className="bz-muted" style={{ fontSize: 'var(--fs-sm)', marginTop: 4 }}>
            Specify how BugZero ingests, scores and routes bugs for this product.
          </div>
        </div>
        {tenantSettingsLoaded && bugCoverageEnabled && vendorCoverage && (
          <CoverageInline coverage={vendorCoverage} vendorId={vendorId} vendorName={currentVendorName} />
        )}
      </div>
      {isReadOnly && !loading && snIntegrationCheck ? (
        <Alert color="info">Note: Your user only has read-only access. You will not be able to save any updates.</Alert>
      ) : (
        <></>
      )}

      {(() => {
        const dynamicSchema = LOCAL_FORM_SCHEMAS[vendorId] || vendor?.vendorData?.formSchema;
        const hasStaticForm = managedProductForms[vendorId];
        const useDynamic = dynamicSchema && (!hasStaticForm || DYNAMIC_FORM_VENDORS.includes(vendorId));
        const FormComponent = useDynamic ? DynamicConfigForm : managedProductForms[vendorId];
        if (!FormComponent) return null;
        return React.createElement(FormComponent, {
          ...(useDynamic ? { formSchema: dynamicSchema } : {}),
          loading: loading,
          vendor: vendor,
          isReadOnly: isReadOnly,
          settings: settings ? settings : {},
          vendorLabel: currentVendorName,
          vendorId,
          bugsDateBack: bugsDateBack ? bugsDateBack : '',
          setBugsDateBack: setBugsDateBack,
          vendorPriorityOptions: vendor?.vendorData?.priorities || [],
          vendorStatusOptions: vendor?.vendorData?.statuses || [],
          vendorSupportStatusOptions: vendor?.vendorData?.vendorSupportStatus || [],
          vendorResolutionOptions: vendor?.vendorData?.vendorBugResolutions || [],
          vendorEventScopeOptions: vendor?.vendorData?.eventScopes || [],
          vendorBugCategoryOptions: vendor?.vendorData?.vendorBugCategories
            ? vendor.vendorData.vendorBugCategories
            : [],
          vendorBugTypeOptions: vendor?.vendorData?.vendorBugTypes ? vendor.vendorData.vendorBugTypes : [],
          vendorBugServiceOptions: vendor?.vendorData?.vendorBugServices ? vendor.vendorData.vendorBugServices : [],
          vendorComplianceStatus: vendorComplianceStatus ? vendorComplianceStatus : [],
          setVendorComplianceStatus: setVendorComplianceStatus,
          vendorComplianceStatusOptions: vendor?.vendorData?.vendorComplianceStatus
            ? vendor.vendorData?.vendorComplianceStatus
            : [],
          setVendorBugServices: setVendorBugServices,
          vendorBugServices: vendorBugServices ? vendorBugServices : [],
          vendorRiskCategoryOptions: vendor?.vendorData?.vendorRiskCategories
            ? vendor.vendorData.vendorRiskCategories
            : [],
          vendorRiskCategories: vendorRiskCategories ? vendorRiskCategories : [],
          setVendorRiskCategories: setVendorRiskCategories,
          snIntegrationCheck: snIntegrationCheck ? snIntegrationCheck : false,
          services: dashboard?.services ? services : [],
          vendors: activeVendors ? activeVendors : [],
          bugs: bugs ? bugs : {},
          priorityStats: priorityStats ? priorityStats : {},
          setPriorityStats: setPriorityStats,
          bugOptions: bugOptions ? bugOptions : [],
          selectedBugOption: selectedBugOption ? selectedBugOption : {},
          setSelectedBugOption: setSelectedBugOption,
          snCompanySysIdOptions: snCompanySysIdOptions ? snCompanySysIdOptions : {},
          snCompanySysIdErrors: snCompanySysIdErrors ? snCompanySysIdErrors : false,
          setVendorResolutions: setVendorResolutions,
          vendorResolutions: vendorResolutions ? vendorResolutions : [],
          vendorStatuses: vendorStatuses ? vendorStatuses : [],
          vendorSupportStatus: vendorSupportStatus ? vendorSupportStatus : [],
          setVendorStatuses: setVendorStatuses,
          setVendorSupportStatus: setVendorSupportStatus,
          fields: fields ? fields : {},
          handleFieldChange: handleFieldChange,
          snCompanySysId: snCompanySysId ? snCompanySysId : {},
          setSnCompanySysId: setSnCompanySysId,
          keywords: keywords ? keywords : [],
          setKeywords: setKeywords,
          priorityMaps: priorityMaps ? priorityMaps : [],
          setPriorityMaps: setPriorityMaps,
          snPriorityOptions: snPriorityOptions ? snPriorityOptions : [],
          searchFields: searchFields ? searchFields : [],
          setSearchFields: setSearchFields,
          customers: customers ? customers : [],
          setServices: setServices,
          isConfigured: isConfigured ? isConfigured : false,
          setVendors: setActiveVendors,
          setBugs: setBugs,
          buildVendorStat: buildVendorStat,
          setCustomers: setCustomers,
          setVendorEventScopes: setVendorEventScopes,
          vendorEventScopes: vendorEventScopes ? vendorEventScopes : [],
          organizations: organizations ? organizations : [],
          setOrganizations: setOrganizations,
          organizationOptions: organizationOptions,
          setOrganizationOptions: setOrganizationOptions,
          excludedApps: excludedApps,
          setExcludedApps: setExcludedApps,
          vendorImpactedRegions: vendorImpactedRegions ? vendorImpactedRegions : [],
          setVendorImpactedRegions: setVendorImpactedRegions,
          vendorImpactedRegionOptions: vendor?.vendorData?.vendorImpactedRegions
            ? vendor.vendorData?.vendorImpactedRegions
            : [],
          subscriptions: subscriptions ? subscriptions : [],
          setSubscriptions: setSubscriptions,
          subscriptionOptions: subscriptionOptions ? subscriptionOptions : [],
          setSubscriptionOptions: setSubscriptionOptions,
          vendorBugTypes: vendorBugTypes ? vendorBugTypes : [],
          setVendorBugTypes: setVendorBugTypes,
          setVendorBugCategories: setVendorBugCategories,
          vendorBugCategories: vendorBugCategories ? vendorBugCategories : [],
          vendorProductBugCategories: vendorProductBugCategories ? vendorProductBugCategories : [],
          setVendorProductBugCategories: setVendorProductBugCategories,
          vendorProductBugCategoryOptions:
            vendor?.vendorData?.vendorProductBugCategories && vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
              ? vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
              : vendor?.vendorData?.vendorBugModules
              ? vendor?.vendorData?.vendorBugModules
              : [],
          syncOnly: syncOnly ? syncOnly : false,
          setSyncOnly: setSyncOnly,
          bugRisk: bugRisk,
          setBugRisk: setBugRisk,
          isCve: isCve,
          resiliencyData: resiliencyData ? resiliencyData : [],
          setIsCve: setIsCve,
          awsResHub: awsResHub,
          setAwsResHub: setAwsResHub,
          autoClose: autoClose,
          setAutoClose: setAutoClose,
          autoCloseBugTicket: autoCloseBugTicket,
          setAutoCloseBugTicket: setAutoCloseBugTicket,
          excludedComponents: excludedComponents,
          setExcludedComponents: setExcludedComponents,
          vendorMitigationTypes: vendorMitigationTypes,
          setVendorMitigationTypes: setVendorMitigationTypes,
          vendorMitigationTypeOptions: vendor?.vendorData?.vendorMitigationTypes,
          isServiceActive: isServiceActive,
          setIsServiceActive: setIsServiceActive,
          awsOrgHealthEnabled: awsOrgHealthEnabled,
          setAwsOrgHealthEnabled: setAwsOrgHealthEnabled,
          allRequired,
          setAllRequired,
          isUpdated,
          setIsUpdated,
          vendorContractType: vendorContractType,
          setVendorContractType: setVendorContractType,
          vendorContractTypeOptions: vendor?.vendorData?.vendorContractType || [],
          enableChatGptPriority: enableChatGptPriority,
          aiEnabled: enableChatGptPriority,
          aiRequired: aiRequired,
          vendorAiEnabled: vendorAiEnabled,
          initialEnableChatGptPriority: initialEnableChatGptPriority,
          onAiEnabledChange: handleAiEnabledChange,
          aiToggleNeedsResave: aiToggleNeedsResave,
          setAiToggleNeedsResave: setAiToggleNeedsResave
        });
      })()}
    </>
  );
}

ManagedProductConfig.propTypes = {
  forms: PropTypes.func,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string
};
